import Component from 'vue-class-component'
import Vue from 'vue'
import EditButton from '@/components/buttons/EditButton';
import ToggleButton from '@/components/buttons/ToggleButton';

@Component({
  props: ['tags', 'isEditable', 'model'],
  components: { 'edit-button' : EditButton, 'toggle-button' : ToggleButton }
})
export default class Tags extends Vue {
  protected isEditing = false;

  protected isHidden = true;

  mounted () {
    const hidden = this.$props['hidden']
    if (hidden != null) this.isHidden = hidden;
  }

  protected show (): void {
    this.isHidden = false;
  }

  protected hide (): void {
    this.isHidden = true;
  }

  protected edit (): void {
    this.isEditing = true;
  }

  protected stopEdit (): void {
    this.isEditing = false;
  }
}
